import { render, staticRenderFns } from "./JobApplicantTable.vue?vue&type=template&id=2165aa8b&scoped=true&"
import script from "./JobApplicantTable.vue?vue&type=script&lang=js&"
export * from "./JobApplicantTable.vue?vue&type=script&lang=js&"
import style0 from "./JobApplicantTable.vue?vue&type=style&index=0&id=2165aa8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2165aa8b",
  null
  
)

export default component.exports